import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { DriverTsaSecurityThreatType } from '../models/driver-tsa-security-threat-type.model';
import { DriverTsaSecurityThreat } from '../models/driver-tsa-security-threat.model';

@Injectable()
export class DriverTsaSecurityThreatService extends BaseApiService {
    public getSecurityThreatTypes = (): Observable<{ result: DriverTsaSecurityThreatType[] }> => this.get('Driver/DriverTSASecurityThreat/Types');

    public getHistory = (customerNumberId: number): Observable<{ result: DriverTsaSecurityThreat[] }> => this.get(`Driver/DriverTSASecurityThreat/${customerNumberId}`);

    public saveSecurityThreat = (model: DriverTsaSecurityThreat): Observable<{ result: DriverTsaSecurityThreat }> => this.post('Driver/DriverTSASecurityThreat', model);

    public deleteSecurityThreat = (driverTsaSecurityThreatId: number): Observable<any> => this.post(`Driver/DriverTSASecurityThreat/Delete/${driverTsaSecurityThreatId}`, null);
}
